interface AuthActionHeaderProps {
  title: string;
  subTitle?: string;
}

const AuthActionHeader = ({ title, subTitle }: AuthActionHeaderProps) => {
  return (
    <h2 className='w-full min-h-max text-center flex flex-col gap-1 ~text-base/3xl line-clamp-1 text-gray-900 dark:text-secondary-dark-900'>
      {title}
      {subTitle ? (
        <span className='~text-xs/base text-gray-600 dark:text-secondary-dark-700'>
          {subTitle}
        </span>
      ) : null}
    </h2>
  );
};

export default AuthActionHeader;
